<template>
  <div>
    <div role="tablist" aria-orientation="horizontal" class="tabs-whats-app">
      <button
        v-for="(option, index) in options"
        :key="index"
        type="button"
        role="tab"
        :aria-selected="selectedOption === option.id"
        :class="['tab', { active: selectedOption === option.id }]"
        @click="selectOption(option.id)"
      >
        <i :class="option.icon" />
        {{ option.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabsWhatsApp",
  props: {
    options: {
      type: Array,
      default: () => [
        { id: "alert-rules", name: "Alert Rules", icon: "el-icon-setting" },
        { id: "alert-history", name: "Alert History", icon: "el-icon-time" },
        { id: "recipients", name: "Recipients", icon: "el-icon-user" },
      ],
    },
    value: {
      type: String,
      default: "alert-rules",
    },
  },
  data() {
    return {
      selectedOption: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.selectedOption = newValue;
    },
    selectedOption(newValue) {
      this.$emit("input", newValue);
    },
  },
  methods: {
    selectOption(optionId) {
      this.selectedOption = optionId;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/element-variables.scss";
.tabs-whats-app {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: $--background-color-base;
  border-radius: 8px;
  padding: 4px;

  .tab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    color: $--color-text-primary;
    background-color: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: $--border-color-lighter;
    }

    &.active {
      background-color: $--color-white;
      color: $--color-primary;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    }

    i {
      font-size: 16px;
    }
  }
}
</style>
